import Tooltip from '@ui-kit/components/tooltip';
import MainButton from '@ui-kit/components/mainButton';
import FormError from '@ui-kit/components/formError';
import PasswordInput from '@ui-kit/components/passwordInput';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { container } from 'tsyringe';
import { IUserService } from '../model/interfaces';
import styles from '../styles/changePassword.module.scss';
import { t } from '@base/utils/helpers';

export default function ChangePassword() {
  return (
    <Tooltip overlay={<ChangePasswordForm />} trigger={'click'} placement={'bottom'}>
      <MainButton>{t('change_password')}</MainButton>
    </Tooltip>
  );
}

enum ChangePasswordFormFields {
  OLD_PWD = 'oldPassword',
  NEW_PWD = 'newPassword',
  NEW_PWD_CONFIRM = 'newPasswordConfirm',
}

function ChangePasswordForm() {
  const userService: IUserService = container.resolve('userService');
  const [loading, setLoading] = useState(false);
  const {
    register,
    formState: { errors, isSubmitSuccessful },
    setError,
    handleSubmit,
    watch,
  } = useForm();

  if (isSubmitSuccessful) return <span>{t('password_changed_successfully')}</span>;

  return (
    <form
      className={styles.changePassword}
      onSubmit={handleSubmit(async (data) => {
        try {
          setLoading(true);
          await userService.changePassword(
            data[ChangePasswordFormFields.OLD_PWD],
            data[ChangePasswordFormFields.NEW_PWD],
            data[ChangePasswordFormFields.NEW_PWD_CONFIRM]
          );
        } catch (e: any) {
          setError(ChangePasswordFormFields.NEW_PWD_CONFIRM, {
            type: 'manual',
            message: e.message,
          });
        } finally {
          setLoading(false);
        }
      })}
    >
      <PasswordInput
        placeholder={t('old_password')}
        {...register(ChangePasswordFormFields.OLD_PWD, {
          required: t('required'),
        })}
      />
      <FormError errors={errors} field="oldPassword" />
      <PasswordInput
        placeholder={t('new_password')}
        {...register(ChangePasswordFormFields.NEW_PWD, {
          required: t('required'),
          pattern: {
            value: /^[a-zA-Z0-9_\-.]+$/,
            message: t('password_restricitons'),
          },
          minLength: {
            value: 6,
            message: t('password_6_characters_long'),
          },
        })}
      />
      <FormError errors={errors} field={ChangePasswordFormFields.NEW_PWD} />
      <PasswordInput
        placeholder={t('confirm_password')}
        {...register(ChangePasswordFormFields.NEW_PWD_CONFIRM, {
          required: t('required'),
          validate: (p) => p === watch(ChangePasswordFormFields.NEW_PWD) || t('passwords_not_match'),
        })}
      />
      <FormError errors={errors} field={ChangePasswordFormFields.NEW_PWD_CONFIRM} />
      <MainButton type="submit" loading={loading}>
        {t('confirm_new_password')}
      </MainButton>
    </form>
  );
}
